(function ($) {
    $(document).ready(function () {

        $('body').on('updated_checkout', function () {
            $('#billing_country_field').prependTo('.woocommerce-shipping-totals.shipping td');
        });


        $(document).on('change', 'form.checkout .qty', function () {
            const data = {
                action: 'bad_luck_games_ajax_cart_quantity',
                cart_item_key: $(this).attr('name'),
                quantity: $(this).val()
            };

            $.post({
                url: wc_add_to_cart_params.ajax_url,
                data,
            }).done(function (data) {
                $('body').trigger('update_checkout');
            });
        });

        $(document).on('change', '#blg-coupon-code', function () {
            $('#coupon_code').val($(this).val());
            $('form.checkout_coupon').submit();
        });
    });
})(jQuery);
